import { useLocation } from "react-router-dom";
import { useMaintenanceMode } from "@/hooks/useMaintenanceMode";
import UnderConstruction from "@/pages/UnderConstruction";

const ALLOWED_PREFIXES = ["/admin", "/dashboard"];

const MaintenanceGate = ({ children }: { children: React.ReactNode }) => {
  const { enabled, isAdmin, loading } = useMaintenanceMode();
  const location = useLocation();

  const isAllowedPath = ALLOWED_PREFIXES.some((p) => location.pathname.startsWith(p));

  if (loading) return <>{children}</>;
  if (enabled && !isAdmin && !isAllowedPath) {
    return <UnderConstruction />;
  }
  return <>{children}</>;
};

export default MaintenanceGate;
